import React, { useState, useEffect } from "react";
import { ApproveActivityEditAnswerFormStyled } from "./styled";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { portalService } from "apiServices";
import { Buttons, Displays, Inputs } from "components";
import { toast } from "react-toastify";

const ApproveActivityEditAnswerForm = ({
  activity_form_id,
  activity_form_history_id,
  initialValues,
  onSuccess,
}) => {
  const schema = yup.object().shape({});

  const {
    control,
    handleSubmit,
    // formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { fields } = useFieldArray({
    control,
    name: `question_list`,
  });

  useEffect(() => {
    if (initialValues) {
      reset({
        question_list: initialValues.question_list,
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const watchAllField = watch();

  const [_isBgLoading, _setIsBgLoading] = useState();

  const _handleApprove = async (key, values) => {
    _setIsBgLoading(true);
    switch (key) {
      case "confirm":
        let paramsConfirm = {
          activity_form_id: activity_form_id,
          activity_form_history_id: activity_form_history_id,
          page: values.page,
          question_id: values._id,
          is_approve: true,
        };
        let resConfirm = await portalService.POST_ACTIVITY_FORM_REQUEST_EDIT(
          paramsConfirm
        );
        if (resConfirm && resConfirm.status === 200) {
          onSuccess && onSuccess();
          _setIsBgLoading(false);
          toast.success("อัพเดตสำเร็จ");
        } else {
          _setIsBgLoading(false);
          toast.error("อัพเดตไม่สำเร็จ");
        }
        break;
      case "reject":
        let paramsReject = {
          activity_form_id: activity_form_id,
          activity_form_history_id: activity_form_history_id,
          page: values.page,
          question_id: values._id,
          is_approve: false,
          reject_new_answer: values.reject_new_answer,
        };
        let resReject = await portalService.POST_ACTIVITY_FORM_REQUEST_EDIT(
          paramsReject
        );
        if (resReject && resReject.status === 200) {
          onSuccess && onSuccess();
          _setIsBgLoading(false);
          toast.success("อัพเดตสำเร็จ");
        } else {
          _setIsBgLoading(false);
          toast.error("อัพเดตไม่สำเร็จ");
        }
        break;
      default:
        break;
    }
  };

  const _onSubmit = () => {};

  return (
    <ApproveActivityEditAnswerFormStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <form onSubmit={handleSubmit(_onSubmit)}>
        {fields &&
          fields.map((item, index) =>
            item.questions.map((item2, index2) =>
              item2.status === "2" ? (
                <div className="question_item" key={item2._id}>
                  <div
                    className="question_html"
                    dangerouslySetInnerHTML={{ __html: item2.question }}
                  />
                  <div className="ans_block">
                    <div className="ans_label">คำตอบเดิม</div>
                    <div className="ans_value">{item2.answer}</div>
                  </div>
                  <div className="ans_block">
                    <div className="ans_label">คำตอบที่ขอแก้ไข</div>
                    <div className="ans_value">{item2.new_answer}</div>
                  </div>
                  <div className="action_block">
                    <Controller
                      control={control}
                      render={({ field }) => (
                        <Inputs.TextArea
                          {...field}
                          placeholder={"เหตุผลการยกเลิก"}
                          // errors={errors.rejection_reason?.message}
                        />
                      )}
                      name={`question_list.${index}.questions.${index2}.reject_new_answer`}
                      defaultValue=""
                    />
                    <div className="action_row">
                      <div className="btn_wrap">
                        <Buttons.BgStandard
                          theme_purple
                          label="ยืนยัน"
                          onClick={() =>
                            _handleApprove("confirm", {
                              ...watchAllField.question_list[index].questions[
                                index2
                              ],
                              page: watchAllField.question_list[index].page,
                            })
                          }
                        />
                      </div>
                      <div className="btn_wrap">
                        <Buttons.BgStandard
                          theme_green
                          label="Reject"
                          onClick={() =>
                            _handleApprove("reject", {
                              ...watchAllField.question_list[index].questions[
                                index2
                              ],
                              page: watchAllField.question_list[index].page,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <span key={item2._id}></span>
              )
            )
          )}
      </form>
    </ApproveActivityEditAnswerFormStyled>
  );
};

export default ApproveActivityEditAnswerForm;
